var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-popup__section text-right"},[_c('button',_vm._g({staticClass:"gc-popup__button-close",on:{"click":function($event){return _vm.hide()}}},_vm.$listeners),[_c('IconClose')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }